export default __webpack_public_path__ + "media/images/coworkr/favicons/icon72-551497139473f504826b43e1c66d2941.png";